export default "__VITE_ASSET__BgsDJV5b__"